import { render, staticRenderFns } from "./AbkPageBackgroundCover.vue?vue&type=template&id=3a79be48&scoped=true&"
import script from "./AbkPageBackgroundCover.vue?vue&type=script&lang=js&"
export * from "./AbkPageBackgroundCover.vue?vue&type=script&lang=js&"
import style0 from "./AbkPageBackgroundCover.vue?vue&type=style&index=0&id=3a79be48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a79be48",
  null
  
)

export default component.exports